import React, { useState } from 'react'
import { object, func } from 'prop-types'
import { Grid, Button } from '@mui/material'
import SmallTextField from '../../../components/textfield/SmallTextfield'
import { Leitores, Emprestimos } from '../../../services/http'
import Dater from '../../../services/DateFormat'

export default function FormEmprestimo({ exemplar, valueModal = () => {} }) {
  const [leitor, setLeitor] = useState({})
  const [cpf, setCpf] = useState('')

  const date = new Date()
  date.setDate(date.getDate() + 30)
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  const currentDate = `${year}-${month}-${day}`

  const fetchLeitor = async cpf => {
    if (cpf.length === 11) {
      const { data } = await Leitores().show({
        'includes[user][cpf]': cpf,
        'includes[user][ativo]': true
      })
      setLeitor({ id: data.data[0]?.id, nome: data.data[0]?.user.name })
    }
  }

  const storeEmprestimos = async () => {
    await Emprestimos().store(
      {
        exemplar_id: exemplar.id,
        leitor_id: leitor.id,
        data_prevista_devolucao: Dater().formatar(currentDate, 'yyyy-mm-dd')
      },
      {
        notification: true,
        message: 'Emprestimo Realizado com sucesso'
      }
    )
  }

  return (
    <Grid container spacing={2} sx={{ overflowY: 'scroll', maxHeight: '50vh' }}>
      <Grid item xs={12} md={12}>
        <SmallTextField
          name="cpf"
          label="CPF"
          value={cpf}
          onChange={({ target }) => {
            setCpf(target.value)
            fetchLeitor(target.value)
          }}
          required
          maxLength={11}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <SmallTextField
          disabled
          name="leitor"
          label="Leitor"
          value={leitor.nome || ''}
          required
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <SmallTextField
          disabled
          name="livro"
          label="Livro"
          value={exemplar.titulo}
          required
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Button
          sx={{ mt: 2 }}
          variant="contained"
          color="leitura"
          onClick={() => {
            storeEmprestimos()
            valueModal(false)
          }}
        >
          Finalizar Empréstimo
        </Button>
      </Grid>
    </Grid>
  )
}

FormEmprestimo.propTypes = {
  exemplar: object,
  valueModal: func
}
